<div id="toggler" class="row align-items-center py-3">
    <div class="col-8">
        <div class="row">
            <label class="col-4 py-0 col-form-label text-end" for="smartlockerIdentifier">
                {{ 'SMARTLOCKER_STORAGE_LOCATION_LABEL' | translate }}
            </label>
            <label class="col text-start" for="smartlockerIdentifier">
                {{ smartlockerData().Identifier }}
            </label>
        </div>
        <div class="row">
            <label class="col-4 py-0 col-form-label text-end" for="smartlockerDoor">
                {{ 'SMARTLOCKER_DOOR' | translate }}
            </label>
            <label class="col text-start" for="smartlockerDoor">
                {{ doorDetails() }}
            </label>
        </div>
        <div class="row">
            <label class="col-4 py-0 col-form-label text-end" for="smartlockerDoorId">
                {{ 'SMARTLOCKER_DOOR_ID' | translate }}
            </label>
            <label class="col text-start" for="smartlockerDoorId">
                {{ doorData().doorData?.SmartlockerDoorId }}
            </label>
        </div>
        <div class="row">
            <label class="col-4 py-0 col-form-label text-end" for="smartlockerAvaliableQty">
                {{ 'SMARTLOCKER_AVAILABLE_QTY_LABEL' | translate }}
            </label>
            <label class="col text-start" for="smartlockerAvaliableQty">{{ doorData().materials.length }}</label>
        </div>
    </div>
    <button
        type="button"
        class="btn btn-primary col-3 col-lg-3"
        [disabled]="smartLockerAccessCode.length > 0"
        (click)="getSmartlockerAccessCode()"
        [translate]="'SMARTLOCKER_GET_SL_ACCESS_CODE_BTN_SHORT_LABEL'"
    ></button>
</div>
@if (smartLockerAccessCode.length > 0) {
    <div class="row py-2 align-items-center">
        <label class="col-4 py-0 col-form-label text-end" for="smartlockerILPN">
            {{ 'SMARTLOCKER_ILPN_LABEL' | translate }}
        </label>
        <div class="col-lg-6 col-8">
            <pace-core-text-input [model]="ilpnInputModel" (valueChange)="checkValidity()"></pace-core-text-input>
            @if (displayError().length > 0) {
                <div class="text-danger">{{ displayError() }}</div>
            }
        </div>
        <button
            type="button"
            class="btn btn-primary col-1"
            (click)="addMaterial()"
            [disabled]="displayError().length > 0 || ilpnInputModel.value.length === 0"
        >
            Add
        </button>
    </div>
    @if (pickedUpMaterialsForDoor().length > 0) {
        @for (pickedUpSmartLockerMaterial of pickedUpMaterialsForDoor(); track pickedUpSmartLockerMaterial) {
            <div class="row">
                <div class="col-lg-8 col-11 text-end">
                    <span class="fw-bold">{{ pickedUpSmartLockerMaterial.ILPN }}</span>
                    <button
                        type="button"
                        class="btn btn-secondary ms-2"
                        (click)="removeMaterial(pickedUpSmartLockerMaterial)"
                    >
                        Remove
                    </button>
                </div>
            </div>
        }
    }
}
